


























/* eslint-disable */

import Vue from "vue";
import fb from "../config";
import router from './router/routes.vue';

export default Vue.extend({
  name: "#contact",
  data() {
    return {
        inquiries:[],
        email:""
    };
  },
  mounted(){
      var cur=this;
      if(!sessionStorage.getItem('user')){
          this.$router.push({ path: '/' })
      }
      else{
          console.log(fb.firestore().collection("inquiry").get())
      }
  },
  methods: {
    logout() {
      var cur = this;
      let email=sessionStorage.getItem('user');
        fb.auth().signOut().then(function() {
            fb.firestore()
        .collection("userlogs")
        .add({
          email: email,
          time:new Date().toLocaleString(),
          action:'logged out'
          
        })
        });
        sessionStorage.removeItem('user');
        cur.$router.push({ path: '/' })
      
    },
  },
});
